// One-tap add for the cart upsell (snippets/vy-cart-upsell.liquid).
// In the drawer it re-renders the drawer from the add response; on the cart page it reloads.
if (!customElements.get('vy-cart-upsell')) {
  customElements.define(
    'vy-cart-upsell',
    class VyCartUpsell extends HTMLElement {
      connectedCallback() {
        this.error = this.querySelector('.vy-upsell__error');
        this.querySelectorAll('button[data-variant-id]').forEach((button) =>
          button.addEventListener('click', () => this.add(button))
        );
      }

      add(button) {
        if (button.getAttribute('aria-disabled') === 'true') return;

        const drawer = this.dataset.layout === 'drawer' ? document.querySelector('cart-drawer') : null;
        const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
        if (drawer) {
          body.sections = drawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        this.error.hidden = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body: JSON.stringify(body) })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);

            if (!drawer) {
              window.location.reload();
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vy-cart-upsell', cartData: response });
            }
            drawer.renderContents({ ...response, id: response.items[0]?.product_id });
          })
          .catch((error) => {
            this.error.textContent = error.message || window.cartStrings?.error;
            this.error.hidden = false;
            button.removeAttribute('aria-disabled');
            button.classList.remove('is-loading');
          });
      }
    }
  );
}
